import { getAreasAccessService } from '../services/knowledgeEditorService';
import { getRolesAccessService } from '../services/roleEditorService';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// async thunk
export const getRolesAccess = createAsyncThunk(
  'editor/getRolesAccess',
  async () => {
    const response = await getRolesAccessService();
    return response.data;
  }
);

export const getAreasAccess = createAsyncThunk(
  'editor/getAreasAccess',
  async () => {
    const response = await getAreasAccessService();
    return response.data;
  }
);

// slice
const editorSlice = createSlice({
  name: 'editor',
  initialState: {
    accessibleRoles: [],
    accessibleAreas: [],
    readOnlyAreas: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getRolesAccess.pending, (state) => {
        console.log('Fetching roles access...');
      })
      .addCase(getRolesAccess.fulfilled, (state, action) => {
        state.accessibleRoles = action.payload.accessibleRoles || [];
      })
      .addCase(getRolesAccess.rejected, (state) => {
        state.accessibleRoles = [];
        state.accessibleAreas = [];
        state.readOnlyAreas = [];
      })
      .addCase(getAreasAccess.pending, (state) => {
        console.log('Fetching areas access...');
      })
      .addCase(getAreasAccess.fulfilled, (state, action) => {
        state.accessibleAreas = action.payload.accessibleModules || [];
        state.readOnlyAreas = action.payload.readOnlyModules || [];
      })
      .addCase(getAreasAccess.rejected, (state) => {
        state.accessibleAreas = [];
        state.readOnlyAreas = [];
      });
  },
});

export default editorSlice.reducer;
export const editorActions = editorSlice.actions;
export const editorSelectors = {
  selectAccessibleRoles: (state) => state.editor.accessibleRoles,
  selectAccessibleAreas: (state) => state.editor.accessibleAreas,
  selectReadOnlyAreas: (state) => state.editor.readOnlyAreas,
};
